export default function tvaList({ tvaList, onTvaClick }) {
    // console.log(tvaList)
    return (
        <>
            <div className="tvaList">
                {
                    tvaList && tvaList.length > 0 &&
                    tvaList.map((tva, index) => {
                        return (
                            <div className='tvaList__line' key={index}>
                                <p
                                    className='tvaList__line_pourcent'
                                    onClick={() => onTvaClick && onTvaClick(tva)}
                                    title="Appliquer la TVA sur tous les articles"
                                >
                                    TVA à {tva.rate}%
                                </p>
                                <p className='tvaList__line_price'>{parseFloat(tva.value || 0).toFixed(2)} €</p>
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}